const userRoleOptions = [
  {
    label: "Select team role",
    value: "",
  },
  {
    label: "01. Admin",
    value: "admin",
  },
  {
    label: "02. Approver / Manager",
    value: "approval_or_manager",
  },
  {
    label: "03. Regular User",
    value: "regular_user",
  },
  {
    label: "04. Non Logistics User",
    value: "non_logistics_user",
  },
  {
    label: "05. Logistics Planner",
    value: "logistics_planner",
  },
  {
    label: "07. Marketplace User",
    value: "marketplace_user",
  },
  {
    label: "08. Forwarder",
    value: "forwarder",
  },
  {
    label: "Supplier",
    value: "supplier",
  },
];

const locationOptions = [
  {
    label: "Koy",
    id: "koy",
  },
  {
    label: "Spartment",
    id: "spartment",
  },
  {
    label: "Vamos",
    id: "vamos",
  },
  {
    label: "Yolao",
    id: "yolao",
  },
  {
    label: "PowerTech",
    id: "powertech",
  },
];

const approvalLevelOptions = [
  {
    label: "Select approval level",
    value: "",
  },
  {
    label: "Supplier - USD 50",
    value: "132",
  },
  {
    label: "Regular User - USD 1000",
    value: "133",
  },
  {
    label: "Plant Manager - USD 100000",
    value: "149",
  },
  {
    label: "Logistics Managers - USD 24999",
    value: "192",
  },
  {
    label: "Logistics supervisor - USD 4999",
    value: "193",
  },
  {
    label: "Executive - USD 1000000",
    value: "199",
  },
  {
    label: "Chief Engineers - USD 5002",
    value: "206",
  },
  {
    label: "Director - USD 100000",
    value: "207",
  },
];

const timezoneOptions = [
  {
    label: "Asia/singapore",
    value: "Asia/singapore",
  },
  {
    label: "US/Central",
    value: "US/Central",
  },
];

const languageOptions = [
  { label: "Please select", value: "" },
  {
    label: "English",
    value: "en",
  },
  {
    label: "German",
    value: "de",
  },
  {
    label: "Espanol",
    value: "es",
  },
  {
    label: "Français",
    value: "fr",
  },
  {
    label: "Simplified Chinese 简体中文",
    value: "zh-cn",
  },
  {
    label: "Japanese - 日本語",
    value: "ja",
  },
  {
    label: "Thai - แบบไทย",
    value: "th",
  },
];

export { userRoleOptions, locationOptions, approvalLevelOptions, timezoneOptions, languageOptions };
